"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _blogSidebar = _interopRequireDefault(require("../BlogView/blog-sidebar"));

require("./style.sass");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BlankPage = function BlankPage(props) {
  var page = props.page,
      loading = props.loading,
      isSocialLinks = props.isSocialLinks,
      links = props.links,
      Skeleton = props.Skeleton;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "wizrd-blog-detail-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wizrd-blog-detail"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wizrd-blog-detail-inner"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wizrd-blog-title"
  }, /*#__PURE__*/_react["default"].createElement("h1", null, page.title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wizrd-blog-feature-img"
  }, !loading ? /*#__PURE__*/_react["default"].createElement("img", {
    className: "image",
    src: page.imageUrl,
    alt: "page-image"
  }) : /*#__PURE__*/_react["default"].createElement(Skeleton, {
    reactangle: true,
    height: 265
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wizrd-blog-description"
  }, loading && /*#__PURE__*/_react["default"].createElement(Skeleton, {
    count: 10,
    height: 15
  }), props.children))));
};

var _default = BlankPage;
exports["default"] = _default;